// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles__heading___1vLrC","headingSection":"styles__headingSection___3nZFq","container":"styles__container___Tvf5C"};